// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".top-header{border-bottom:1px solid hsla(0,0%,88%,.7);height:80px}", "",{"version":3,"sources":["webpack://./resources/js/layouts/navigation/TopNavComponent.vue"],"names":[],"mappings":"AACA,YAEE,yCAAA,CADA,WACF","sourcesContent":["\r\n.top-header {\r\n  height: 80px;\r\n  border-bottom: 1px solid rgba(224, 224, 224, 0.7);\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
